import axios, { AxiosRequestConfig } from 'axios';
import { SS12InvoiceRunReport } from '../models/SS12InvoiceRunReport';
import CSharpUtils from './CSharpUtils';
import Utils from './Utils';

/**
 * SS12 Fakturering per kjøring: the four invoice runs of a month for the store(s), compared with the
 * same point last year, plus a product group table for each invoiced run and for the month so far.
 * month = YYYYMM; butikkId = one store or a comma-separated list summed together.
 */
export const fetchSS12InvoiceRunReport = (month: string, butikkId: string) => {
  const config: AxiosRequestConfig = {
    method: 'get',
    url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/invoiceruns/report`,
    params: { Month: month, ButikkId: butikkId },
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    responseType: 'json',
    // A big store's first load reads every invoice line since 1 January for two years (~10-15 s).
    timeout: 60000,
  };

  return axios.request<SS12InvoiceRunReport>(config);
};

export interface SS12ExportParams {
  /** YYYYMM. */
  month: string;
  butikkId: string;
  /** The store selection as the page shows it, for the file's heading. */
  storeNames: string;
  /** The selected run (1-4); 0 = the whole month so far. */
  run: number;
  showAccumulated: boolean;
  /** The product group table's sort column, e.g. 'nettoLastYear'. */
  sortBy: string;
  sortDescending: boolean;
}

/** The page as an Excel or PDF file: month, stores, selected run, visible columns and sort order. */
export const fetchSS12Export = (format: 'excel' | 'pdf', p: SS12ExportParams) => {
  const config: AxiosRequestConfig = {
    method: 'get',
    url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/invoiceruns/report/${format}`,
    params: { Month: p.month, ButikkId: p.butikkId, StoreNames: p.storeNames, Run: p.run, ShowAccumulated: p.showAccumulated,
      SortBy: p.sortBy, SortDescending: p.sortDescending },
    headers: { Authorization: `Bearer ${CSharpUtils.Get_Token}` },
    responseType: 'blob',
    timeout: 120000,
  };

  return axios.request<Blob>(config);
};
